export default (val) => {
  if (val) {
    document.body.classList.add('hide-chat');
  } else {
    document.body.classList.remove('hide-chat');
  }
};